import { render, staticRenderFns } from "./AssetReports.vue?vue&type=template&id=bbce4a2a&scoped=true"
import script from "./AssetReports.vue?vue&type=script&lang=js"
export * from "./AssetReports.vue?vue&type=script&lang=js"
import style0 from "./AssetReports.vue?vue&type=style&index=0&id=bbce4a2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce4a2a",
  null
  
)

export default component.exports